import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorMessage from '../components/ErrorMessage';
import OrderCard from '../components/OrderCard';
import './OrderPage.css';

function OrderPage() {
  const { token } = useParams();
  const [appointmentData, setAppointmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setError('No appointment token provided. Please check the URL.');
      setLoading(false);
      return;
    }

    const fetchAppointmentData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await axios.get(
          `https://vitaldev.vitalinsights.in/appointment/order-page/${token}`,
          {
            timeout: 10000,
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.data.status === true && response.data.code === 200) {
          setAppointmentData(response.data.data[0]);
          setError(null);
        } else {
          setError(response.data.message || 'Failed to fetch appointment data');
          setAppointmentData(null);
        }
      } catch (err) {
        let errorMessage = 'Failed to load appointment data';
        
        if (err.response) {
          if (err.response.status === 404) {
            errorMessage = 'Appointment not found. Please check the token.';
          } else if (err.response.status === 400) {
            errorMessage = 'Invalid appointment token.';
          } else if (err.response.status === 500) {
            errorMessage = 'Server error. Please try again later.';
          } else {
            errorMessage = err.response.data?.message || `Error: ${err.response.status}`;
          }
        } else if (err.request) {
          errorMessage = 'Unable to connect to the server. Please check your internet connection.';
        } else {
          errorMessage = err.message;
        }
        
        setError(errorMessage);
        setAppointmentData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointmentData();
  }, [token]);

  return (
    <div className="order-page">
      <Navbar />
      <div className="main-container">
        {loading && <LoadingSpinner />}
        {error && <ErrorMessage message={error} />}
        {appointmentData && <OrderCard data={appointmentData} />}
      </div>
    </div>
  );
}

export default OrderPage;
